import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

function PhonePreview() {
  return (
    <div className="relative mx-auto w-full max-w-none sm:max-w-[38rem] lg:max-w-[44rem]">
      <div className="phone-float relative">
        <Image
          src="/images/hero-phone-2.png"
          alt="sendtochef app preview on a mobile phone"
          width={1080}
          height={1080}
          priority
          className="h-auto w-full"
        />
      </div>
    </div>
  );
}

export function LandingHeroSection() {
  return (
    <>
      <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fbf7f1_0%,#f4ecdf_56%,#f0e4d4_100%)] px-4 pt-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.95),rgba(255,255,255,0)_42%)]" />
        <div className="orb-float absolute top-24 right-[-5rem] size-56 rounded-full bg-[#efc7ae]/55 blur-3xl" />
        <div className="orb-float-delay absolute top-[36rem] left-[-4rem] size-48 rounded-full bg-[#e2e8d7] blur-3xl" />

        <div className="relative mx-auto max-w-6xl">
          <header className="flex items-center justify-between py-4">
            <p className="text-2xl font-semibold tracking-[-0.04em] text-black">
              sendtochef
            </p>

            <Button
              asChild
              variant="ghost"
              className="h-10 px-3 text-sm text-[#5f564c] hover:bg-black/[0.04] hover:text-black"
            >
              <Link href="/account/login">Sign in</Link>
            </Button>
          </header>

          <div className="mx-auto flex max-w-[28rem] flex-col items-center justify-start pt-8 text-center sm:min-h-[calc(100svh-5.5rem)] sm:max-w-[34rem] sm:pt-10 lg:max-w-[48rem]">
            <div className="max-w-[24rem] sm:max-w-[31rem] lg:max-w-[43rem]">
              <p className="animate-fade-in-up text-[11px] font-semibold tracking-[0.18em] text-[#7f7468] uppercase opacity-0">
                Deciding what to eat - solved.
              </p>

              <h1 className="animate-fade-in-up animation-delay-100 mt-4 text-[2.45rem] leading-[0.98] font-semibold tracking-[-0.04em] text-black opacity-0 sm:mt-5 sm:text-[4.35rem] sm:leading-[0.94] sm:tracking-[-0.05em] lg:text-[4.6rem] lg:leading-[0.96]">
                Turn Instagram reels into recipes your whole family can use.
              </h1>

              <p className="animate-fade-in-up animation-delay-200 text-20px] mt-4 leading-7 text-[#5e554b] opacity-0 sm:mt-5 sm:text-base">
                Save once, share instantly, and pick meals together.
              </p>

              <div className="animate-fade-in-up animation-delay-300 mt-8 flex justify-center opacity-0">
                <Button
                  asChild
                  size="lg"
                  className="group h-12 rounded-full bg-[#111111] px-6 text-sm text-white hover:bg-black"
                >
                  <Link href="/account/signup">
                    Start free
                    <ArrowRight className="transition-transform duration-300 group-hover:translate-x-0.5" />
                  </Link>
                </Button>
              </div>
            </div>

            <div className="animate-fade-in-scale mt-5 w-[90vw] max-w-none self-center sm:mt-6 sm:w-[128%] sm:max-w-none lg:w-[132%]">
              <PhonePreview />
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .phone-float {
          animation: phone-float 7s ease-in-out infinite;
        }

        .orb-float {
          animation: orb-float 12s ease-in-out infinite;
        }

        .orb-float-delay {
          animation: orb-float 14s ease-in-out infinite reverse;
        }

        @keyframes phone-float {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes orb-float {
          0%,
          100% {
            transform: translate3d(0, 0, 0);
          }
          50% {
            transform: translate3d(0, 16px, 0);
          }
        }
      `}</style>
    </>
  );
}
